export const next7DaysArray = ['day0', 'day1', 'day2', 'day3', 'day4', 'day5', 'day6'] as const;

export type Next7Days = (typeof next7DaysArray)[number];
